import React, { useState } from "react";
import { V_URL_API } from "../../../../../../utils/config";
import BotonRecurso from "./components/BotonRecursos";

export default function RecursosCursosComprados({ cursoData, getToken }) {
  const [loadingId, setLoadingId] = useState(null);

  const handleDownload = async (idRecurso, nombre) => {
    const url = `${V_URL_API}/api/descargar_recurso/${idRecurso}?_t=${Date.now()}`;
    setLoadingId(idRecurso);

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `E ${getToken}`,
        },
      });

      if (!response.ok) throw new Error("Error al descargar recurso");

      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = nombre || "recurso.pdf"; // Fallback
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error al descargar:", error);
      alert("Hubo un problema al descargar el recurso.");
    } finally {
      setLoadingId(null);
    }
  };

  const moveScrollTo = (element, targetScroll, speed) => {
    const currentScroll = element.scrollLeft;
    const distance = targetScroll - currentScroll;
    const step = Math.sign(distance) * Math.min(Math.abs(distance), speed); // Limitar el paso para evitar saltos grandes
  
    const move = () => {
      const currentScroll = element.scrollLeft;
      const distance = targetScroll - currentScroll;
  
      // Si estamos cerca del destino, ajustamos el scroll a la posición exacta
      if (Math.abs(distance) <= Math.abs(step)) {
        element.scrollLeft = targetScroll;
      } else {
        element.scrollLeft += step;
        requestAnimationFrame(move); // Continuar el movimiento
      }
    };
  
    move();
  };
  
  

  const handleMouseEnter = (e) => {
    const textoContenedor = e.target.querySelector(".recurso-titulo-texto");
    if (textoContenedor) {
      const maxScrollLeft = textoContenedor.scrollWidth - textoContenedor.clientWidth;
      moveScrollTo(textoContenedor, maxScrollLeft,1); // Ajuste a velocidad adecuada
    }
  };
  
  const handleMouseLeave = (e) => {
    const textoContenedor = e.target.querySelector(".recurso-titulo-texto");
    if (textoContenedor) {
      moveScrollTo(textoContenedor, 0, 1); // Regresar al inicio
    }
  };
  
  

  return (
    <>
      <div data-figma-id="782:2859" className="curso-alumno-recursos-glosario">
        <div data-figma-id="775:3339" className="curso-alumno-texto-glosario">
          Glosario gráfico
        </div>
        <div
          data-figma-id="775:3340"
          className="curso-alumno-recursos-botones-1"
        >
          <div data-figma-id="775:3341" className="curso-alumno-boton-video">
            <i className="fi fi-rr-video-camera-alt video-camera-alt-2"></i>
            <div data-figma-id="775:3343" className="curso-alumno-texto-video">
              Video
            </div>
          </div>
          <div
            data-figma-id="775:3344"
            className="curso-alumno-boton-infografia"
          >
            <i className="fi fi-rs-stats stats-2"></i>
            <div
              data-figma-id="775:3346"
              className="curso-alumno-texto-infografia"
            >
              Infografía
            </div>
          </div>
          <div
            data-figma-id="775:3347"
            className="curso-alumno-boton-presentacion"
          >
            <i className="fi fi-rr-dashboard-monitor dashboard-monitor-2"></i>
            <div
              data-figma-id="775:3349"
              className="curso-alumno-texto-presentacion"
            >
              Presentación General
            </div>
          </div>
          <div
            data-figma-id="775:3350"
            className="curso-alumno-boton-plantilla"
          >
            <i className="fi fi-rr-file-edit file-edit-3-2"></i>
            <div
              data-figma-id="775:3352"
              className="curso-alumno-texto-plantilla"
            >
              Plantilla de Excel
            </div>
          </div>
          <div
            data-figma-id="775:3350"
            className="curso-alumno-boton-documento"
          >
            <i className="fi fi-rr-folder-open fi_545285"></i>
            <div
              data-figma-id="775:3352"
              className="curso-alumno-texto-plantilla"
            >
              Documento
            </div>
          </div>
        </div>
      </div>
      <div className="apartados-video-2">
        <div className="curso-alumno-texto-glosario">
          <p>Recursos</p>
        </div>
        <div className="frame-290177">
        {console.log(cursoData?.detail?.datos?.CURSO_RECURSOS?.recursos)}
          {cursoData?.detail?.datos?.CURSO_RECURSOS?.recursos?.map(
            (recurso) => (
              <BotonRecurso
                recurso={recurso}
                getToken={getToken}
                />
            )
          )}
        </div>
      </div>
    </>
  );
}
